import React, { useState } from 'react';
import ReactPlayer from 'react-player';
import * as S from './styles';

const Header: React.FC = () => {
  const [visible, setVisible] = useState<boolean>(false);
  return (
    <S.Container>
      <S.VideoWrapper visible={visible}>
        <ReactPlayer
          url="https://www.youtube.com/watch?v=8IgxJ58Jmr4"
          width={`100%`}
          height={`100%`}
          playing={visible}
          controls
        />
      </S.VideoWrapper>
      <S.PlayButton
        onClick={() => setVisible(true)}
        className="wow animate__animated animate__fadeIn"
        data-wow-duration="1s"
        data-wow-delay="1s"
      >
        <S.PlayIcon />
      </S.PlayButton>
      <S.Tapume
        className="wow animate__animated animate__fadeIn"
        data-wow-duration="1s"
      />
      <S.TapumeMobile
        className="wow animate__animated animate__fadeIn"
        data-wow-duration="1s"
      />
    </S.Container>
  );
};

export default Header;
